import styled from 'styled-components'

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`

export const Row = styled.div`
  display: flex;
  gap: 8px;
  align-items: flex-end;
  width: 100%;
`

export const ToggleButton = styled.div`
  display: flex;
  cursor: pointer;
  margin-bottom: 6px;

  &:hover {
    opacity: 0.7;
  }
`
